import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography, Grid, Dialog, DialogTitle, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { MessageBox } from 'components/MessageBox/MessageBox';
import useHttp from 'hooks/useHttp';
import { scrollIntoView } from 'utils/scroll';
import { RESEND_REPORT_URL } from 'api/report';
import { HTTP_METHODS } from 'constants';

const TITLE = 'Resend notification';

export const ResendNotificationModal = ({ open, onClose, onSuccess, reportId }) => {
    const topElementRef = useRef();
    const { data, error, clearData, sendRequest: resendNotification, loading } = useHttp();
    const [messageType, setMessageType] = useState('none');
    const [responseMessage, setResponseMessage] = useState('');

    useEffect(() => {
        clearData();

        if (error !== null) {
            setResponseMessage(error.response?.data?.message || 'An error occurred');
            setMessageType('error');
        }

        if (data) {
            onSuccess('Notification sent successfully.', 'success');
            onClose();
        }
    }, [error, data, messageType]);

    const handleResendNotificationConfirmation = async () => {
        if (reportId) {
            await resendNotification({
                url: `${RESEND_REPORT_URL}/${reportId}`,
                method: HTTP_METHODS.POST,
            });
        }
        scrollIntoView(topElementRef);
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle style={{ textTransform: 'none' }}>
                {TITLE}
                <Button onClick={onClose} variant="CloseButton">
                    <CloseIcon />
                </Button>
            </DialogTitle>
            <DialogContent>
                <Grid width={500} ref={topElementRef}>
                    {messageType !== 'none' && (
                        <MessageBox messageType={messageType}>{responseMessage}</MessageBox>
                    )}
                    {messageType !== 'success' && (
                        <Grid item xs={5}>
                            <Typography>
                                Are you sure you want to resend notification about this report?
                            </Typography>
                            <Box mt={2} display="flex" justifyContent="flex-end">
                                <Button
                                    onClick={onClose}
                                    variant="outlined"
                                    sx={{ marginRight: '8px' }}
                                    disabled={loading}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    onClick={handleResendNotificationConfirmation}
                                    variant="contained"
                                    disabled={loading}
                                >
                                    Send
                                </Button>
                            </Box>
                        </Grid>
                    )}
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

ResendNotificationModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    reportId: PropTypes.string.isRequired,
};
